module.exports = __webpack_public_path__ + "img/a876d23.jpg";